/* eslint-disable @typescript-eslint/no-explicit-any */
import { Conditional } from '@consumidor-positivo/aurora';

import { MMForm } from './Form';
import { MMResult } from './Result';
import { useMatchMaker } from './hook';

export type MatchMakerProps = {
  user?: any;
  token: string;
  negativeDebts?: any[];
  headers?: {
    loggedIn: React.ReactNode;
    loggedOut: React.ReactNode;
  };
};

export function MatchMaker({ user, token, negativeDebts, headers }: MatchMakerProps) {
  const { completedForm, safeUser, onCompleteForm, clearForm } = useMatchMaker({ user, token, negativeDebts });

  return (
    <Conditional
      condition={completedForm}
      renderIf={
        <>
          <Conditional condition={user?.fullName || user?.full_name} renderIf={headers?.loggedIn} renderElse={headers?.loggedOut} />
          <MMResult token={token} clearForm={clearForm} user={safeUser} />
        </>
      }
      renderElse={<MMForm user={user} token={token} negativeDebts={negativeDebts} onFinish={onCompleteForm} />}
    />
  );
}
